module.exports = __webpack_public_path__ + "static/fonts/iconfont.852f4ee6.woff2";